import React from 'react'
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Typography
} from '@mui/material'
import { RoundedButton } from 'common/Button/Button'

interface FaberConfirmVoucherDeleteDialogProps {
  open: boolean
  onClose: () => void
  onConfirm: () => void
  numVouchers: number
}

export default function FaberConfirmVoucherDeleteDialog(
  props: FaberConfirmVoucherDeleteDialogProps
) {
  const { open, onClose, onConfirm, numVouchers } = props
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth='md'
      sx={{ minWidth: '500px' }}
    >
      <DialogTitle>
        <Typography
          sx={{ color: 'black', fontSize: '18px', fontWeight: '700', p: 0 }}
        >
          Confirm delete vouchers
        </Typography>
      </DialogTitle>
      <Divider sx={{ width: '100%' }} />
      <DialogContent>
        <Typography
          sx={{ color: 'black', fontSize: '16px', fontWeight: '500' }}
        >
          {numVouchers} vouchers will be permanently deleted. Confirm?
        </Typography>
      </DialogContent>
      <DialogActions>
        <RoundedButton variant='outlined' onClick={onClose}>
          Cancel
        </RoundedButton>
        <RoundedButton variant='filled' type='submit' onClick={onConfirm}>
          Confirm
        </RoundedButton>
      </DialogActions>
    </Dialog>
  )
}
